// Zmenšení velkých rastrových ikon (hlavně AI PNG) před uložením do knihovny.
// Server převede plnobarevné PNG na PNG s paletou – vypadá stejně, má zlomek velikosti.
import { getAppCheckHeader } from './firebase';
import type { IconType } from '../types';

/** Ikony nad touto velikostí (délka data URL) se zmenšují. */
export const BIG_ICON_CHARS = 80_000;

// PNG s paletou (typ barev 3 v hlavičce IHDR) je už zmenšené – znovu se nepřevádí.
const isPalettePng = (data: string) => {
  try {
    const b64 = data.slice(data.indexOf(',') + 1, data.indexOf(',') + 1 + 48);
    return atob(b64).charCodeAt(25) === 3;
  } catch { return false; }
};

export const isBigRasterIcon = (i: IconType) =>
  typeof i.data === 'string' && i.data.length > BIG_ICON_CHARS && /^data:image\/(png|jpe?g|webp);base64,/.test(i.data) &&
  !(i.data.startsWith('data:image/png') && isPalettePng(i.data));

export async function shrinkImageData(data: string): Promise<string> {
  try {
    const res = await fetch('/api/shrink-image', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...(await getAppCheckHeader()) },
      body: JSON.stringify({ data }),
    });
    if (!res.ok) return data;
    const j = await res.json();
    return typeof j.data === 'string' && j.data.length < data.length ? j.data : data;
  } catch {
    return data;
  }
}

/** Vrátí seznam ikon, kde jsou velké rastrové obrázky zmenšené (ostatní beze změny). */
export async function shrinkBigIcons(icons: IconType[]): Promise<{ icons: IconType[]; changed: number; savedBytes: number }> {
  let changed = 0, savedBytes = 0;
  const out = await Promise.all(icons.map(async i => {
    if (!isBigRasterIcon(i)) return i;
    const d = await shrinkImageData(i.data);
    if (d === i.data) return i;
    changed++; savedBytes += i.data.length - d.length;
    return { ...i, data: d };
  }));
  return { icons: out, changed, savedBytes };
}
